import { Resource } from 'src_common/common/mobx-utils/Resource';
import { ApiGetSettingsResponse200Type } from 'src/api_openapi/v2/settingsService/apiGetSettings';
import { makeAutoObservable } from 'mobx';
import { AutoWeakMap } from 'src_common/common/mobx-utils/AutoWeakMap';
import { Common } from 'src/AppState/Common';
import { action, computed } from 'src_common/common/mobx-wrapper';

export class ServiceSettingsFormState {
    // This flag is used to reset value on check 'Use Default Value' checkbox and is set to false in onChange handler from  <Form> component
    // @observable public shouldSubmitFlag: boolean = false;
    public readonly serviceSettings: Resource<ApiGetSettingsResponse200Type['data'] | null>;
    public idsValueToSendAsNull: Array<string> = [];

    public static get = AutoWeakMap.create(
        (_common: Common, serviceId: string) => new ServiceSettingsFormState(serviceId)
    );
    private constructor(private readonly serviceId: string) {
        makeAutoObservable(this);
        this.serviceSettings = new Resource(async (): Promise<ApiGetSettingsResponse200Type['data'] | null> => {
            const response = await $appState.sdkStaff.settingsService.getServiceSettings(this.serviceId);
            if (response.status === 200) {
                return response.body.data;
            }

            console.error('getServiceSettings error', response);
            return null;
        });
    }

    @action public addPath(path: string): void {
        this.idsValueToSendAsNull.push(path);
    }

    @action public removePath(pathToRemove: string): void {
        this.idsValueToSendAsNull = this.idsValueToSendAsNull.filter((path) => pathToRemove !== path);
    }

    // @action public setShouldSubmitFlag = (value: boolean): void => {
    // this.shouldSubmitFlag = value;
    // };

    public toggleServiceSettings = (): void => {
        console.log('toggleServiceSettings ');
    };

    public onSubmit = async (data: unknown): Promise<void> => {
        console.log('Data submitted: ', data);
        console.log('this.idsValueToSendAsNull ', this.idsValueToSendAsNull);
        // @ts-expect-error
        await $appState.sdkStaff.settingsService.patchServiceSettings(this.serviceId, data.formData);
        await this.serviceSettings.refresh();
    };

    public onError = (errors: unknown): void => {
        console.log('Errors: ', errors);
    };

    @computed public getReady = (): ApiGetSettingsResponse200Type['data'] | null => {
        return this.serviceSettings.getReady();
    };

    @computed public getCustomValuePaths = (): string[] => {
        const serviceSettings = this.serviceSettings.getReady();
        if (serviceSettings === null) {
            return [];
        }
        return serviceSettings.customValuePaths;
    };
}
